import { createSelector } from 'reselect';
import { featuresIsPremiumSelector, userSelector, } from '@xingternal/platform-layout-selectors';
import { xingConnect } from '@xingternal/frame-data-provider';
import { UserFlag as UserFlagComponent } from './user-flag';
const combiner = (user, isPremium) => {
    var _a;
    return ({
        viewerUserId: (user === null || user === void 0 ? void 0 : user.id) || 0,
        viewerDisplayFlag: ((_a = user === null || user === void 0 ? void 0 : user.userFlags) === null || _a === void 0 ? void 0 : _a.displayFlag) || 'BASIC',
        isPremium,
    });
};
const selector = createSelector(userSelector, featuresIsPremiumSelector, combiner);
const UserFlag = xingConnect(selector)(UserFlagComponent);
export { UserFlag };
//# sourceMappingURL=user-flag.container.js.map